const fromEvent = (event) => (target, handler) => {
    target.addEventListener(event, (e) => handler(target, e));
    return target;
};

export default fromEvent;
